module.exports = __webpack_public_path__ + "assets/Wallet.0bf0ec58.svg";